<template lang="">
    <div v-if="periodData.total > 0" class="wrapper">
        <h5>Статистика по файлу: "{{this.fileTitle}}"</h5>
        <div>
            <div class="stat__wrapper">
            <div class="period__select">
                <h6>Выберите период</h6>
                <select @change="setOption" class="selector">
                    <option selected disabled>Период</option>
                    <option
                    :key="option.id"
                    :value="option.value"
                    v-for="option in optionValues"
                    >{{option.value}}</option>
                </select>
            </div>
            <div class='chart'>
                <Bar v-if="dashboardYData.length !== 0 && this.dashboardYData.every(el => el !== '0.0')"
                        id="my-chart-id"
                        :options="chartOptions"
                        :data="chartData"
                    />
                    <Bar v-else-if="dashboardYData.length === 0 || this.dashboardYData.every(el => el === '0.0')"
                        id="my-chart-id"
                        :options="chartOptions"
                        :data="chartData"
                        :plugins=[noData]
                    />
            </div>
            </div>
        </div>
    </div>
    <div v-else class="wrapper">
        <h5>По файлу ещё нет статистики</h5>
    </div>
</template>
<script>
import AnalyticsChart from '@/mixins/AnalyticsChart';


export default {
    name: 'FileAnalytics',
    mixins: [AnalyticsChart],
    props: ['id'],
    data(){
        return{
            optionValues: [
                {id: 1, value: 'Вчера'},
                {id: 2, value: 'Сегодня'},
                {id: 3, value: 'Прошлый месяц'},
                {id: 4, value: 'Этот месяц'},
                {id: 5, value: 'Текущий год'},
            ],
            optionValue: '',
            periodData: [],
            fileTitle: '',
            chartOptions: {
                responsive: true
        },
        }
    },
    mounted(){
        this.getFileStatSummary(this.id);
        this.getFileTitle();
    },
    unmounted(){
        this.periodData = []
    },
    computed: {
      chartData() {
        return {
            labels: this.dashboardXData,
            datasets: [
            {
                label:  'Время воспроизведения, ч.',
                backgroundColor: ['#f87979', '#8AAE56', '#4287f5', '#4242f5', '#9191d9', '#bca1cf',  '#a155d4', '#bd62bd', '#cf4674', '#46b8cf', '#2ca397',
                '#48c29f', '#84f5af', '#b2f7ad', '#d3f0b6', '#f5e449', '#f5ad49', '#f58349', '#b84c2e', '#730d0d'],
                data: this.dashboardYData
            } 
            ]
            }
      }
    },
    methods:{
        async getFileTitle(){
        try{
            const res = await fetch('/api/files/list');
            const data = await res.json();
            const currentFile = data.result.filter(d => d.id === this.id);
            this.fileTitle = currentFile[0].name;
            console.log(this.fileTitle)

        }catch(e){
            console.log(e);
        }
        },
        async getFileStatSummary(){
            try{
                const res = await fetch(`/api/statistics/file/${this.id}/currentYear`);
                const data = await res.json();
                this.periodData = data.result;
                console.log(this.periodData)
            }catch(e){
                console.log(e)
            }
        },
        async getFileStatYesterday(){
            try{
                const res = await fetch(`/api/statistics/file/${this.id}?period=yesterday`)
                const data = await res.json();
                console.log(data.result)
                this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
                this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))

            }catch(e){
                console.log(e)
            }
        },
        async getFileStatToday(){
            try{
                const res = await fetch(`/api/statistics/file/${this.id}?period=today`)
                const data = await res.json();
                console.log(data.result)
                this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
                this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))

            }catch(e){
                console.log(e)
            }
        },
        async getFileStatLastMonth(){
            try{
                this.dashboardXData = [];
                this.dashboardYData = [];
                const res = await fetch(`/api/statistics/file/${this.id}?period=last_month`)
                const data = await res.json();
                console.log(data.result)
                this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
                this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))

            }catch(e){
                console.log(e)
            }
        },
        async getFileStatThisMonth(){
            try{
                this.dashboardXData = [];
                this.dashboardYData = [];
                const res = await fetch(`/api/statistics/file/${this.id}?period=this_month`)
                const data = await res.json();
                console.log(data.result)
                this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
                this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))

            }catch(e){
                console.log(e)
            }
        },
        async getFileStatThisYear(){
            try{
                this.dashboardXData = [];
                this.dashboardYData = [];
                const res = await fetch(`/api/statistics/file/${this.id}?period=this_year`)
                const data = await res.json();
                console.log(data.result)
                this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
                this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))

            }catch(e){
                console.log(e)
            }
        },
        setOption(e){
            this.optionValue = e.target.value;
            if(this.optionValue === 'Вчера'){
                this.getFileStatYesterday();
            }else if (this.optionValue === 'Сегодня'){
                this.getFileStatToday();
            }else if (this.optionValue === 'Прошлый месяц'){
                this.getFileStatLastMonth();
            }else if (this.optionValue === 'Этот месяц'){
                this.getFileStatThisMonth();
            }else{
                this.getFileStatThisYear();
            }
            
        }
    },

}
</script>
<style scoped>
    .wrapper{
        max-width: 1200px;
        margin:  25px auto;
        font-size: 18px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .wrapper h5{
        text-align: center;
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 25px;
    }
    .wrapper h6{
        font-size: 24px;
        font-weight: 400;
        text-align: center;
        margin-top: 50px;
    }
    h6 span{
        text-decoration: underline;
    }
    .stat__wrapper{
        margin-top: 70px;
        display: flex;
        justify-content: space-between;
    }
    .period__select h6{
        margin-top: 10px;
    }
    .selector{
        width: 300px;
        height: 43px;
        border-radius: 5px;
        margin-top: 25px;
        padding-left: 15px;
        font-size: 18px;
        outline: none;
        background-color: transparent;
        border: 2px solid teal;
        cursor: pointer;
    }
    .chart{
        display: flex;
        justify-content: center;
        width: 800px;
    }
    @media screen and (max-width:1600px){
        .chart{
        width: 700px;
    } 
}
    @media screen and (max-width:1366px){
        .selector{
            width: 200px;
        }
        .chart{
        width: 600px;
    }
}
@media screen and (max-width: 1280px) {
        .chart{
        width: 500px;
    }
    }
    @media screen and (max-width: 1024px) {
        .stat__wrapper{
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .selector{
            width: 460px;
        }
        .chart{
            margin-top: 40px;
            width: 600px;
        }
    }
    @media screen and (max-width: 920px) {
        .wrapper h5{
            font-size: 26px;
        }
        .wrapper h6{
            font-size: 22px;
        }
        .selector{
            width: 360px;
        }
        .chart{
            width: 500px;
        }
    }
    @media screen and (max-width: 820px) {
        .selector{
            width: 250px;
        }
        .chart{
            width: 400px;
        }
    }
    @media screen and (max-width: 730px) {
        .wrapper h5{
            font-size: 20px;
        }
        .wrapper h6{
            font-size: 18px;
        }
        .selector{
            width: 250px;
            font-size: 16px;
        }
        .chart{
            width: 350px;
            font-size: 0px;
        }
    }
    @media screen and (max-width: 640px){
        .chart{
            width: 500px;
        }
    }
    @media screen and (max-width: 520px){
        .chart{
            width: 450px;
        }
    }
    @media screen and (max-width: 470px){
        .chart{
            width: 400px;
        }
    }
    @media screen and (max-width: 410px){
        .chart{
            width: 350px;
        }
    }
</style>